// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__QHi61","inputWrap":"CustomTip_inputWrap__1R-rp"};